module.exports = __webpack_public_path__ + "c0f98ba8d62f45fee5d20ce942df97db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/client/images/M&G_Investments.jpg
// module id = 368
// module chunks = 0